export function isTouchDevice() {
    return 'ontouchstart' in window        // works on most browsers
        || navigator.maxTouchPoints;       // works on IE10/11 and Surface
}

export function isCordovaApp() {
    return !!window.cordova;
}



/** WEBPACK FOOTER **
 ** ./src/utils/Browser.js
 **/